import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — Iter389 (durci)
 * =============================
 * Garantit qu'à chaque navigation :
 *   • Le scroll repart en haut.
 *   • TOUS les styles inline résiduels susceptibles de bloquer le scroll
 *     sont nettoyés (legacy `useBodyLock`, `EntrainementEcrit` overflow
 *     hidden, modales orphelines, etc.).
 *
 * Liste exhaustive des styles à nettoyer (couvre les hooks/modales
 * existants : useBodyLock, BookingActionsMenu, HelpMobileSheet,
 * HelpDesktopModal, Navbar mobile, EntrainementEcrit) :
 *   body.position = 'fixed'
 *   body.top, body.left, body.right, body.width
 *   body.overflow = 'hidden'
 *   body.height
 *   html.overflow = 'hidden'
 *   html.height
 *
 * Ces styles inline ne sont PAS supprimés en production si un composant
 * crashe ou si l'utilisateur navigue programmatiquement avant le cleanup
 * React. Cette protection garantit que le scroll souris/trackpad/clavier
 * desktop est TOUJOURS rétabli au changement de route.
 *
 * Aucune régression mobile : sur tactile, le scroll natif reste piloté
 * par les styles globaux (`body { overflow-y: auto }` mobile media query),
 * ce nettoyage ne fait que retirer les overrides inline.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset scroll vertical
    try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
    catch (_) { window.scrollTo(0, 0); }

    const body = document.body;
    const html = document.documentElement;

    // ── Body : retire tous les styles inline qui bloquent le scroll ──
    if (body.style.position === 'fixed') body.style.position = '';
    if (body.style.top) body.style.top = '';
    if (body.style.left) body.style.left = '';
    if (body.style.right) body.style.right = '';
    if (body.style.width) body.style.width = '';
    if (body.style.overflow === 'hidden') body.style.overflow = '';
    // Note : height='100%' est posé par EntrainementEcrit (cleanup OK),
    // mais on défensifie aussi ici en cas de unmount asymétrique.
    if (body.style.height === '100%' || body.style.height === '100vh') {
      body.style.height = '';
    }

    // ── HTML : idem (legacy EntrainementEcrit + modales custom) ──
    if (html.style.overflow === 'hidden') html.style.overflow = '';
    if (html.style.height === '100%' || html.style.height === '100vh') {
      html.style.height = '';
    }
  }, [pathname]);

  return null;
}
